export default __webpack_public_path__ + "static/media/background_reports_plataform.6c144b3f.png";